import { Action, Reducer } from 'redux';

import { EditorTable, EntrancePosition } from 'components/tableMaps/CreateTableMapWizard/context';
import {
    EditorArea,
    SizeMeters,
    TableShapeSizes,
} from 'components/tableMaps/CreateTableMapWizard/mapGeometry';
import { TableMapsAction } from './actions';

export interface TableMapListItem {
    id: string;
    name: string;
    tablesCount: number;
    totalSeats: number;
    status: 'Active' | 'Inactive';
    updatedAt: string | null;
}

export interface TableMapDetails {
    id: string;
    name: string;
    /** Derived: true when ≥1 table has IsActive=true. */
    isActive: boolean;
    gridEnabled: boolean;
    entrance: EntrancePosition | null;
    size: SizeMeters;
    area: EditorArea;
    /** Derived: per-shape sizes read back off the saved tables — never persisted. */
    tableDefaults: TableShapeSizes;
    tables: EditorTable[];
    publishedAt: string | null;
}

export interface TableMapsState {
    list: TableMapListItem[];
    isLoading: boolean;
    details: { [id: string]: TableMapDetails };
    detailsLoading: boolean;
}

const initialState: TableMapsState = {
    list: [],
    isLoading: false,
    details: {},
    detailsLoading: false,
};

export const reducer: Reducer<TableMapsState> = (
    state: TableMapsState | undefined,
    incomingAction: Action
): TableMapsState => {
    if (state === undefined) {
        return initialState;
    }

    const action = incomingAction as TableMapsAction;

    switch (action.type) {
        case 'TABLE_MAPS_GET_START':
            return { ...state, isLoading: true };
        case 'TABLE_MAPS_GET_SUCCESS':
            return { ...state, isLoading: false, list: action.list };
        case 'TABLE_MAPS_GET_ERROR':
            return { ...state, isLoading: false };
        case 'TABLE_MAP_DELETE': {
            const { [action.id]: _removed, ...restDetails } = state.details;
            return {
                ...state,
                list: state.list.filter((item) => item.id !== action.id),
                details: restDetails,
            };
        }
        case 'TABLE_MAP_CREATE':
            return { ...state, list: [...state.list, action.item] };
        case 'TABLE_MAP_UPDATE':
            return {
                ...state,
                list: state.list.map((i) => (i.id === action.item.id ? action.item : i)),
                details: { ...state.details, [action.details.id]: action.details },
            };
        case 'TABLE_MAP_DETAILS_LOADING':
            return { ...state, detailsLoading: action.loading };
        case 'TABLE_MAP_DETAILS_SET':
            return {
                ...state,
                detailsLoading: false,
                details: { ...state.details, [action.details.id]: action.details },
            };
        default:
            return state;
    }
};
